import { EventName } from '@lit/react';
import { BlocksPopover } from 'blocks-nextjs/blocks-web-components/components/popover/popover';
import { BlocksCloseEvent, BlocksOpenEvent, BlocksCancelEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatPopover = createComponent({
  react: React,
  tagName: 'cat-popover',
  elementClass: BlocksPopover,
  events: {
    onBlPopoverClose: 'bl-popover-close' as EventName<BlocksCloseEvent>,
    onBlPopoverOpen: 'bl-popover-open' as EventName<BlocksOpenEvent>,
    onBlPopoverCancel: 'bl-popover-cancel' as EventName<BlocksCancelEvent>
  }
});
